import React, { Component } from 'react';
import { connect } from 'react-redux';
import AddCategoryForm from '../../../components/SiteAdmin/AddCategoryForm'

export class AddCategory extends Component {

    render() {
        return (
            <AddCategoryForm />
        )
    }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(AddCategory)

